const location = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
export default {
    makhazinApi: 'https://localhost:5001',
    lockTimeout: 30,
    lightTimeout: 900,
    routes: {
        booking: `${location}/price.html`,
    },
    dibsCheckoutKey: 'test-checkout-key-5b6fb741914d4ce8b8d46fff336e0870',
    dibsCheckoutJsUrl: 'https://test.checkout.dibspayment.eu/v1/checkout.js?v=1',
};
